import axios from "axios";
import { API_ROOT, ROOT_URL, ACCESS_API_ROOT, COLLECTIONS } from "./urls";
import forEach from "lodash/forEach";
import store from "../store";
//USERS
export function associateRecord(associateRecordObject) {
  return axios
    .post(`${ACCESS_API_ROOT}/api/associate/`, associateRecordObject)
    .then(response => {
      return response.data;
    });
}
//ACLS
export function addAcl(newAclObj) {
  const url = `${ROOT_URL}access/api/add-acl/`;
  return new Promise(resolve => {
    axios.post(url, newAclObj).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function changeDelegateStatus(delegateStatusObj) {
  const url = `${ROOT_URL}access/api/edit-delegate/`;
  return new Promise(resolve => {
    axios.post(url, delegateStatusObj).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function revokeAuth(removeaclobj) {
  const url = `${ROOT_URL}access/api/ungrant-access/`;
  return new Promise(resolve => {
    axios.post(url, removeaclobj).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function getMyAcls(username) {
  const url = `${ACCESS_API_ROOT}/api/${username}/user-list/`;
  return new Promise(resolve => {
    axios.get(url).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function getRecordsIAmAuthorizedOn() {
  const url = `${ACCESS_API_ROOT}/api/get-my-accounts/`;
  return new Promise(resolve => {
    axios.get(url).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}

//ORDERS
export function getOrderProto(orderProtoObj) {
  const url = `${ROOT_URL}order/api/get-order-proto/`;
  return new Promise(resolve => {
    axios.post(url, orderProtoObj).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
//MESSAGING
export function addRecipientToChannel(data) {
  const url = `${ROOT_URL}message/api/add-to-channel/`;
  return new Promise(resolve => {
    axios.put(url, data).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function removeRecipientFromChannel(data) {
  const url = `${ROOT_URL}message/api/remove-from-channel/`;
  return new Promise(resolve => {
    axios.put(url, data).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function deleteChannel(data) {
  const url = `${ROOT_URL}message/api/${data.accountname}/${data.channelname}/delete-channel/`;
  return new Promise(resolve => {
    axios.get(url).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function getMyMessages(username) {
  const url = `${ROOT_URL}message/api/${username}/load/`;
  return new Promise(resolve => {
    axios
      .get(url)
      .then(res => {
        const data = res.data;
        resolve(data);
      })
      .catch(res => {
        const data = res.data;
        resolve(data);
      });
  });
}
export function setupNewConversation(newConvoObj) {
  const url = `${ROOT_URL}message/api/conversation-proto/`;
  return new Promise(resolve => {
    axios.post(url, newConvoObj).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function getMessageProto(currentConversationObj) {
  const url = `${ROOT_URL}message/api/${currentConversationObj._id}/msg-proto/`;
  return new Promise(resolve => {
    axios.get(url).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function sendMessage(messageObj) {
  const url = `${ROOT_URL}message/api/send/`;
  return new Promise(resolve => {
    axios.post(url, messageObj).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function deleteSingleMessage(deletemessageobj) {
  const url = `${ROOT_URL}message/api/delete-msg/ `;
  return new Promise(resolve => {
    axios.delete(url, { data: { ...deletemessageobj } }).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}
export function markMessageAsRead(readMessageObj) {
  const url = `${ROOT_URL}message/api/mark-as-read/`;
  return new Promise(resolve => {
    axios.post(url, readMessageObj).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
}

export function jwtInterceptor() {
  axios.interceptors.request.use(request => {
    // add auth header with jwt if account is logged in and request is to the api url
    const isLoggedIn = true;
    const isApiUrl = request.url.startsWith(ROOT_URL);

    if (isLoggedIn && isApiUrl) {
      request.headers.common.Authorization = `JWT Token`;
    }

    return request;
  });
}

export const fetchFindIndex = (collection, filter) => {
  const url = `${API_ROOT}/${collection}/find-one/`;
  return new Promise(resolve => {
    axios.post(url, filter).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
};

export const deleteFromCollection = (collection, id) => {
  const url = `${API_ROOT}/${collection}/${id}/`;
  return new Promise(resolve => {
    axios.delete(url).then(res => {
      const data = res.data;
      resolve(data);
    });
  });
};

export const fetchFilteredCollection = (collection, filter) => {
  const url = `${API_ROOT}/${collection}/find/`;
  return new Promise(resolve => {
    axios
      .post(url, filter)
      .then(res => {
        const data = res.data;
        resolve(data);
      })
      .catch(error => {
        resolve({ error: error });
      });
  });
};

export class API {
  findOne(collection, filter) {
    const url = `${API_ROOT}/${collection}/find-one/`;
    return axios.post(url, filter);
  }
  find(collection, filter) {
    const url = `${API_ROOT}/${collection}/find/`;
    return axios.post(url, filter);
  }
  post(collection, data) {
    if (!Array.isArray(data)) {
      data = [data];
    }
    const url = `${API_ROOT}/${collection}/`;
    return axios.post(url, data);
  }
  replaceOne(collection, id, data) {
    const url = `${API_ROOT}/${collection}/${id}/`;
    return axios.post(url, data);
  }
  deleteOne(collection, id) {
    const url = `${API_ROOT}/${collection}/${id}/`;
    return axios.delete(url);
  }
  async getCategoryDefinitionsById(thestore) {
    // Returns all categories and templates in an object keyed by id
    let allCategoryDefinitions = {};
    await this.find("templates", {})
      .then(response => {
        forEach(response.data, function(categoryDefinition) {
          allCategoryDefinitions[categoryDefinition._id] = categoryDefinition;
        });
        this.find("terms", {}).then(response => {
          forEach(response.data, function(template) {
            allCategoryDefinitions[template._id] = template;
          });
          store.commit("setAllCategoryDefinitionsById", {
            categoryDefinitions: allCategoryDefinitions
          });
        });
      })
      .catch(error => {
        console.error(error);
      });
    return allCategoryDefinitions;
  }
  getTypes() {
    return new Promise((resolve, reject) => {
      resolve({
        data: [
          {
            key: "section",
            display_name: "Section",
            description: "Section",
            needs_data: false,
            class: "complex"
          },
          {
            key: "numerical-range",
            display_name: "Numerical range",
            description:
              "Range of numerical values separated by a colon (e.g. -1:150)",
            needs_data: true,
            class: "simple"
          },
          {
            key: "date",
            display_name: "Date",
            description: "Date",
            needs_data: false,
            class: "simple"
          },
          {
            key: "value",
            display_name: "Value",
            description: "Single value.  May be either numerical or a string.",
            needs_data: false,
            class: "simple"
          },
          {
            key: "value-list",
            display_name: "Value list",
            description: "One or more values separated by commas.",
            needs_data: true,
            class: "simple"
          },
          {
            key: "multiple-value-list",
            display_name: "Multiple value list",
            description: "One or more values separated by commas.",
            needs_data: true,
            class: "simple"
          },
          {
            key: "category",
            display_name: "Category",
            description: "An existing Category",
            needs_data: true,
            class: "simple"
          }
        ]
      });
    });
  }

  async updateIndex(index, index_id) {
    if (!index_id) {
      return this.post("indexes", index);
    } else {
      if (index["_id"]) {
        delete index["_id"];
      }
      return this.replaceOne("indexes", index_id, index);
    }
  }

  /*
   * These api calls replace the legacy calls above that are deprecated.
   * More calls are added as needed.
   * each call returns a promise.
   */
  get_record_names(pattern) {
    /* return the [{name: nn, _id: yy}, ..] of medical records matching the
       case insensitivbe pattern.
    */
    const url = `${API_ROOT}/${pattern}/get_recs`;

    return axios.get(url);
  }
  get_record_name(id) {
    /* return the {name: nn, _id: yy} of medical record given its id.
     */
    const url = `${API_ROOT}/${id}/get_rec`;
    return axios.get(url);
  }
  get_child_fields(parent_id) {
    /* return the children (entire fields) of children of their parent whose id
       is parent_id and are contained in the medical record root_id
    */
    const url = `${API_ROOT}/${parent_id}/get_children`;
    return axios.get(url);
  }
  get_siblings(my_id) {
    /* return the children (entire fields) of children of their parent whose id
       is parent_id and are contained in the medical record root_id
    */
    const url = `${API_ROOT}/${my_id}/get_siblings`;
    return axios.get(url);
  }
  get_parent(my_id) {
    /* return the children (entire fields) of children of their parent whose id
       is parent_id and are contained in the medical record root_id
    */
    const url = `${API_ROOT}/${my_id}/get_parent`;
    return axios.get(url);
  }
  get_parent_children(my_id) {
    /* return the children (entire fields) of children of their parent whose id
       is parent_id and are contained in the medical record root_id
    */
    const url = `${API_ROOT}/${my_id}/get_parent_children`;
    return axios.get(url);
  }
  get_whole_rec(my_id) {
    /* Get whole record from root with children embedded
     */
    const url = `${API_ROOT}/${my_id}/get_whole_rec`;
    return axios.get(url);
  }
}
